export default class ApiConstants {
  static tournamentsListUrl = `${process.env.REACT_APP_PARSE_BASE_URL}/tournamentStatus`;
  // "https://prod-golf.thriwe.com/parse/classes/tournamentStatus";

  static participants = `${process.env.REACT_APP_BASE_URL}/participants`;

  static competitionMaster = `${process.env.REACT_APP_BASE_URL}/competitionMaster`;

  static golfCourseHoleDetails = `${process.env.REACT_APP_BASE_URL}/golfcourseHoleDetails`;

  static competitionLeaderboard = `${process.env.REACT_APP_BASE_URL}/competitionLeaderboards`;

  static competitionHandicapCategories = `${process.env.REACT_APP_BASE_URL}/getHandicapCategory`;

  static parseGolfGeneralScores = `${process.env.REACT_APP_PARSE_BASE_URL}/golfGeneralScores`;
  // static playerScoresUrl2 =
  //   "https://prod-golf.thriwe.com/parse/classes/golfScoringGameMainLeaderboard";

  static playerScoresUrl = `${process.env.REACT_APP_PARSE_BASE_URL}/golfScoringGameScores`;
  // "https://prod-golf.thriwe.com/parse/classes/golfScoringGameScores";

  static authToken = `Bearer ${process.env.REACT_APP_AUTH_TOKEN}`;

  static parseApplicationId = process.env.REACT_APP_APPLICATION_ID;
  static parseClientKey = process.env.REACT_APP_CLIENT_KEY;
  static parseMasterKey = process.env.REACT_APP_MASTER_KEY;
}
